import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row my-5" }
const _hoisted_2 = { class: `ml-2 text-px xxl:text-18px text-black-lp-100 font-semibold` }
const _hoisted_3 = { class: "flex flex-row gap-4" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col flex-1 gap-4"
}
const _hoisted_5 = {
  key: 1,
  class: "flex flex-col gap-4 flex-1"
}
const _hoisted_6 = {
  key: 2,
  class: "flex flex-col flex-1 gap-4"
}
const _hoisted_7 = {
  key: 3,
  class: "flex-1"
}
const _hoisted_8 = { class: "flex flex-col flex-1 gap-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_UploadFile = _resolveComponent("UploadFile")!

  return (_openBlock(), _createBlock("section", null, [
    _createVNode(_component_Title, {
      class: "mb-4",
      fontSize: 20,
      label: _ctx.$t('clientManagement.managementDetail.taxInfoTitle')
    }, null, 8, ["label"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Checkbox, {
        id: 
          _ctx.routeTypeName === 'edit-client-parent'
            ? 'checkbox_tax_nik_edit_client_parent'
            : 'checkbox_tax_nik_create_client_parent'
        ,
        modelValue: _ctx.formModel.isEfakturWithNik,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formModel.isEfakturWithNik = $event)),
        binary: true,
        onChange: _ctx.onKTPCheckChange
      }, null, 8, ["id", "modelValue", "onChange"]),
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("clientManagement.registrationForm.tax.taxpayerUsesIdCard")), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.formModel.isEfakturWithNik)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.nikNumber'),
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: "Masukan nomor KTP",
                  maxLength: _ctx.taxNumberMaxLength,
                  errorCaption: 
              _ctx.formErrorModel.NIKNumberMessage || 'Masukan nomor KTP'
            ,
                  format: _ctx.formatNumber,
                  modelValue: _ctx.formModel.NIK,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formModel.NIK = $event)),
                  error: _ctx.formErrorModel.NIKNumber,
                  onChange: _ctx.validateNIKOrNpwp,
                  id: 
              _ctx.routeTypeName === 'edit-client-parent'
                ? 'input_nik_id_edit_client_parent'
                : 'input_nik_id_create_client_parent'
            ,
                  showMaxLength: ""
                }, null, 8, ["maxLength", "errorCaption", "format", "modelValue", "error", "onChange", "id"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.nameAsIdCard'),
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterNameAsIdCard')
            ,
                  maxLength: "100",
                  errorCaption: 
              _ctx.$t('clientManagement.registrationForm.tax.enterNameAsIdCard')
            ,
                  modelValue: _ctx.formModel.NIKName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formModel.NIKName = $event)),
                  id: 
              _ctx.routeTypeName === 'edit-client-parent'
                ? 'input_nik_name_edit_client_parent'
                : 'input_nik_name_create_client_parent'
            ,
                  onChange: _ctx.changeKtpOrNpwpName
                }, null, 8, ["placeholder", "errorCaption", "modelValue", "id", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.addressAsIdCard'),
              asterisk: "",
              fontSize: 14,
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterAddressAsIdCard')
            ,
                  type: "textarea",
                  maxLength: "200",
                  modelValue: _ctx.formModel.NIKAddress,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formModel.NIKAddress = $event)),
                  onChange: _ctx.changeNikOrNpwpAddress,
                  id: 
              _ctx.routeTypeName === 'edit-client-parent'
                ? 'input_nik_address_edit_client_parent'
                : 'input_nik_address_create_client_parent'
            
                }, null, 8, ["placeholder", "modelValue", "onChange", "id"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.formModel.isEfakturWithNik)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.taxRegistrationNumber'),
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterNpwpNumber')
            ,
                  modelValue: _ctx.formModel.taxNumber,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formModel.taxNumber = $event)),
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.registrationForm.tax.nameAsNpwp'),
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterNameAsNpwp')
            ,
                  modelValue: _ctx.formModel.taxName,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formModel.taxName = $event)),
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.addressAsTaxId'),
              asterisk: "",
              fontSize: 14,
              class: "mt-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterAddressAsNpwp')
            ,
                  type: "textarea",
                  modelValue: _ctx.formModel.taxAddress,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formModel.taxAddress = $event)),
                  disabled: "",
                  disableBackground: ""
                }, null, 8, ["placeholder", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.formModel.isEfakturWithNik)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.taxRegistrationNumber'),
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  "data-testid": "client-tax-npwp-input",
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterNpwpNumber')
            ,
                  showMaxLength: "",
                  maxLength: _ctx.taxNumberMaxLength,
                  modelValue: _ctx.formModel.taxNumber,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formModel.taxNumber = $event)),
                  error: _ctx.formErrorModel.NIKNumber,
                  errorCaption: 
              _ctx.formErrorModel.NIKNumberMessage || 'Masukan Nomor NPWP'
            ,
                  format: _ctx.formatNumber,
                  onChange: _ctx.validateNIKOrNpwp
                }, null, 8, ["placeholder", "maxLength", "modelValue", "error", "errorCaption", "format", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.registrationForm.tax.nameAsNpwp'),
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterNameAsNpwp')
            ,
                  modelValue: _ctx.formModel.taxName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formModel.taxName = $event)),
                  maxLength: "100",
                  onChange: _ctx.changeKtpOrNpwpName
                }, null, 8, ["placeholder", "modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_DataWrapper, {
              label: 
            _ctx.$t('clientManagement.managementDetail.taxInvoiceTransactionCode')
          ,
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomDropdown, {
                  class: "mt-2",
                  placeholder: 
              _ctx.$t(
                'clientManagement.registrationForm.tax.selectTaxTransactionCode'
              )
            ,
                  customValueStyle: "text-sm",
                  customOptionStyle: "text-sm",
                  options: _ctx.transactionCodeList,
                  selectedItem: _ctx.formModel.transactionCode,
                  modelValue: _ctx.formModel.transactionCode,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formModel.transactionCode = $event))
                }, null, 8, ["placeholder", "options", "selectedItem", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.formModel.isEfakturWithNik)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _createVNode(_component_DataWrapper, {
              label: _ctx.$t('clientManagement.managementDetail.addressAsTaxId'),
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  placeholder: 
              _ctx.$t('clientManagement.registrationForm.tax.enterAddressAsNpwp')
            ,
                  type: "textarea",
                  class: "w-full",
                  textAreaRows: "10",
                  maxLength: "200",
                  modelValue: _ctx.formModel.taxAddress,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formModel.taxAddress = $event)),
                  onChange: _ctx.changeNikOrNpwpAddress
                }, null, 8, ["placeholder", "modelValue", "onChange"])
              ]),
              _: 1
            }, 8, ["label"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_8, [
        (_ctx.formModel.isEfakturWithNik)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: 
            _ctx.$t('clientManagement.managementDetail.taxInvoiceTransactionCode')
          ,
              asterisk: "",
              fontSize: 14
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CustomDropdown, {
                  class: "mt-2",
                  placeholder: 
              _ctx.$t(
                'clientManagement.registrationForm.tax.selectTaxTransactionCode'
              )
            ,
                  customValueStyle: "text-sm",
                  customOptionStyle: "text-sm",
                  options: _ctx.transactionCodeList,
                  selectedItem: _ctx.formModel.transactionCode,
                  modelValue: _ctx.formModel.transactionCode,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formModel.transactionCode = $event))
                }, null, 8, ["placeholder", "options", "selectedItem", "modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('clientManagement.managementDetail.taxIdOrIdCardPhoto'),
          asterisk: "",
          fontSize: 14,
          class: _ctx.formModel.isEfakturWithNik ? 'mt-2' : ''
        }, {
          default: _withCtx(() => [
            _createVNode(_component_UploadFile, {
              id: 
              _ctx.routeTypeName === 'edit-client-parent'
                ? 'input_upload_tax_image_edit_client_parent'
                : 'input_upload_tax_image_create_client_parent'
            ,
              titleChange: 
              _ctx.$t('clientManagement.registrationForm.tax.changeFile')
            ,
              type: "",
              caption: ".pdf up to 5 MB",
              allowed: ".pdf, image/jpeg, image/jpg, image/png",
              maxSize: 5,
              isDraggable: false,
              modelValue: _ctx.formModel.attachment,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formModel.attachment = $event)),
              url: _ctx.formModel.attachmentUrl,
              name: _ctx.formModel.fileNameAttachment,
              longName: 40,
              onError: _cache[14] || (_cache[14] = 
              (error) => {
                _ctx.formErrorModel.taxFile = error;
              }
            ),
              onUpdateFilename: _cache[15] || (_cache[15] = 
              () => {
                _ctx.formModel.attachmentUrl = '';
                _ctx.formModel.fileNameAttachment = '';
              }
            ),
              isClearable: ""
            }, null, 8, ["id", "titleChange", "modelValue", "url", "name"])
          ]),
          _: 1
        }, 8, ["label", "class"])
      ])
    ])
  ]))
}